<template>
    <div v-if="params && params.isActive">
        <ModalDefault @close="close();" :loading="loading">
            <template slot="main">
                <div class="d-flex justify-content-center container flex-column">
                    <p class="modal-title">{{ $t("common.create") }}</p>

                    <div class="form-group row">
                        <DefaultTextInputBloc
                            :label="$t('zone.name')"
                            :required="true"
                            v-model="zoneGroupName"
                            :max-length="99"
                        ></DefaultTextInputBloc>
                    </div>

                    <div class="d-flex align-items-center mt-4 admin-role-switch-client-admin">
                        <label class="switch switch-m" for="zonesForRight">
                            <input type="checkbox" id="zonesForRight" v-model="forRight" :checked="forRight" />
                            <span class="slider round" :style="{ 'background-color': forRight ? currentBrand.linksColor : '' }"></span>
                        </label>
                        <span class="ml-3">{{ $t("zoneGroups.zonesForRight") }}</span>
                    </div>

                    <div class="d-flex align-items-center mt-4 admin-role-switch-client-admin">
                        <label class="switch switch-m" for="zonesForDashboard">
                            <input type="checkbox" id="zonesForDashboard" v-model="forDashboard" :checked="forDashboard" />
                            <span class="slider round" :style="{ 'background-color': forDashboard ? currentBrand.linksColor : '' }"></span>
                        </label>
                        <span class="ml-3">{{ $t("zoneGroups.zonesForDashboard") }}</span>
                    </div>

                    <div class="d-flex justify-content-end mt-4">
                        <ClientColorButton
                            :inactiveColor="!isFormValidated"
                            :background-color="currentBrand.linksColor"
                            @click="saveZoneGroups();"
                            class="mr-3"
                            :disabled="!isFormValidated"
                        >
                            {{ $t("common.save") }}
                        </ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="close();">{{ $t("actions.cancel") }}</ClientColorButton>
                    </div>
                </div>
            </template>
        </ModalDefault>
    </div>
</template>

<script>
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import TextareaInputBloc from "@/components/ui/Form/TextareaInputBloc";
import zoneGroupService from "@/services/zoneGroup";
import historyService from "@/services/history";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import DefaultTextInputBloc from "@/components/ui/Form/DefaultTextInputBloc";
import { mapState } from "vuex";

export default {
    name: "create-zone-groups",
    data() {
        return {
            zoneGroupName: null,
            forRight: false,
            forDashboard: false,
            loading: false
        };
    },
    components: {
        DefaultTextInputBloc,
        DefaultTextareaInputBloc,
        ModalDefault,
        ModalTheme,
        TextInputBloc,
        TextareaInputBloc
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    watch: {},
    mounted() {},
    methods: {
        close() {
            this.params.isActive = false;
            this.$emit("close");
        },
        saveZoneGroups() {
            const zoneGroup = {
                name: this.zoneGroupName,
                forRight: this.forRight,
                forDashboard: this.forDashboard
            };
            try {
                this.loading = true;
                zoneGroupService
                    .create(zoneGroup)
                    .then(res => {
                        this.loading = false;
                        this.dialogSuccess("success");
                        this.$emit("success", res.id);
                        this.close();
                    })
                    .catch(() => {
                        this.loading = false;
                        this.dialogError("error");
                    });
            } catch (e) {
                this.dialogError("error");
            }
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
        isFormValidated() {
            return !!this.zoneGroupName && (this.forRight || this.forDashboard);
        }
    }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// CreateZoneGroups.vue?b2f0d82c